import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'iot-platform-ui-association-card-container',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="iot-platform-ui-association-card-container">
      <ng-content />
    </div>
  `
})
export class AssociationCardContainerComponent {}
